

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 存储sessionStorage
 */
export const setSession = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getSession = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 删除sessionStorage
 */
export const removeSession = name => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}

/**
 * 获取多语言对应的api
 */
export const getLanguageUrl = (url) => {
  let languageData = {
    "zh_CN": "",//中文简体
    "en_US": "EN",//英文
    "zh_TW": "TW",//中文繁体
    "th_TH": "TH",//泰文
  }
  let localeLanguage = window.localStorage.getItem("localeLanguage")
  if (!localeLanguage) {
    localeLanguage = "zh_CN"
  }
  if (localeLanguage == 'zh_CN') {
    return url
  }
  return url + `/${languageData[localeLanguage]}`
}

/**
 * 获取多语言图片后缀
 */
export const getImageLanguage = () => {
  let languageData = {
    "zh_CN": "cn",//中文简体
    "en_US": "en",//英文
    "zh_TW": "tw",//中文繁体
    "th_TH": "th",//泰文
  }
  let localeLanguage = window.localStorage.getItem("localeLanguage")
  if (!localeLanguage) {
    return "cn"
  }
  return languageData[localeLanguage]
}


/**
 * 获取多语言图片后缀
 */
 export const getApiLanguage = () => {
  let languageData = {
    "zh_CN": "CN",//中文简体
    "en_US": "EN",//英文
    "zh_TW": "TW",//中文繁体
    "th_TH": "TH",//泰文
  }
  let localeLanguage = window.localStorage.getItem("localeLanguage")
  if (!localeLanguage) {
    return "CN"
  }
  return languageData[localeLanguage]
}


/**
 * 判断是否ipad
 */
export const isIpad = () => {
  var result = window.matchMedia("(min-width: 1025px)").matches;
  return !result
}

/**
 * 判断ipad横竖屏
 */
export const isIpadDirection = () => {
  let type = 1
  if (window.orientation === 180 || window.orientation === 0) {//竖屏
    console.log("竖屏")
    type = 1
  }
  if (window.orientation === 90 || window.orientation === -90) {//横屏
    type = 2
    console.log("横屏")
  }
  return type
}


//   //为ipad横屏添加样式
//   function hengshuping(){
//     if(window.orientation===180||window.orientation===0){//竖屏
//         document.getElementsByTagName('body')[0].classList.remove('ipadheng');
//     }
//     if(window.orientation===90||window.orientation===-90){//横屏
//         document.getElementsByTagName('body')[0].classList.add('ipadheng');
//     }
// }
// window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", hengshuping, false);



// -拷贝
export function clone(obj) {
  // Handle the 3 simple types, and null or undefined
  if (obj == null || typeof obj !== 'object') return obj

  // Handle Date
  if (obj instanceof Date) {
    const copy = new Date()
    copy.setTime(obj.getTime())
    return copy
  }

  // Handle Array
  if (obj instanceof Array) {
    const copy = []
    for (let i = 0, len = obj.length; i < len; ++i) {
      copy[i] = clone(obj[i])
    }
    return copy
  }

  // Handle Object
  if (obj instanceof Object) {
    const copy = {}
    for (const attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr])
    }
    return copy
  }

  throw new Error("Unable to copy obj! Its type isn't supported.")
}
// 判断是否为字符串
export function isString(str) {
  return (typeof str == 'string') && str.constructor == String;
}





// WEBPACK FOOTER //
// ./src/utils/index.js